import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import './FeedbackButton.css';

const FeedbackButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className="feedback-button"
        onClick={() => setIsModalOpen(true)}
        title="Send Beta Feedback"
        aria-label="Send Beta Feedback"
      >
        <span className="feedback-icon">💬</span>
        <span className="feedback-text">Feedback</span>
      </button>

      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FeedbackButton;
